import React from 'react';
import { subscriptionTiers } from '../services/subscriptionService';
import '../styles/SubscriptionPlan.css';

const SubscriptionPlan = ({ tier, isCurrentPlan, onUpgrade }) => {
  const plan = subscriptionTiers[tier];
  
  return (
    <div className={`subscription-plan ${isCurrentPlan ? 'current-plan' : ''}`}>
      <div className="plan-header">
        <h3 className="plan-name">{plan.name}</h3>
        <div className="plan-price">
          <span className="price">${plan.price}</span>
          <span className="period">/month</span>
        </div>
      </div>
      
      <div className="plan-limits">
        <div className="limit-item">
          <span className="limit-label">Property Analyses:</span>
          <span className="limit-value">
            {plan.propertyAnalyses === -1 ? 'Unlimited' : plan.propertyAnalyses}
          </span>
        </div>
        <div className="limit-item">
          <span className="limit-label">Chat Messages:</span>
          <span className="limit-value">
            {plan.chatMessages === -1 ? 'Unlimited' : plan.chatMessages}
          </span>
        </div>
      </div>
      
      <div className="plan-features">
        <h4>Features:</h4>
        <ul>
          {plan.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
      
      <div className="plan-actions">
        {isCurrentPlan ? (
          <button className="current-plan-button" disabled>
            Current Plan
          </button>
        ) : (
          <button 
            className="upgrade-button"
            onClick={() => onUpgrade(tier)}
          >
            {plan.price === 0 ? 'Downgrade' : 'Upgrade'}
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPlan;